import { useMutation } from '@tanstack/react-query';

import { createBrioTask } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { CreateTaskVariablesBrio } from '../types';

export default function useCreateTaskBrio() {
  return useMutation({
    mutationFn: ({
      crmPartyId,
      description,
      type,
      priority,
      dueDate,
      assignedTo,
      isPersonalNote,
      isVisibleInMyBroker,
    }: CreateTaskVariablesBrio) =>
      createBrioTask(
        {
          params: {
            path: { brio_party_id: crmPartyId },
            query: {},
          },
          body: {
            description,
            type,
            priority: priority === 'NORMAL' ? undefined : priority,
            due_date: dueDate ?? undefined,
            assigned_to: assignedTo ?? undefined,
            is_personal_note: isPersonalNote,
            is_visible_in_my_broker: isVisibleInMyBroker,
          },
        },
        wgApi,
      ),
  });
}
